import Component from '../core/Component'
import { substitute } from '../utils/String'
import CursorTrigger from '../meta/CursorTrigger'

const STATES = {
    PLAYING: 'is-playing',
}

const defaults = {
    controls: false,
}

export default class Video extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            placeholder: null,
            playButton: null,
            template: null,
            video: null,
        }

        this.template = null
        this.cursor = null
    }

    prepare() {
        this.element.addEventListener('contextmenu', (event) => event.preventDefault())
        this.template = this.ref.template?.textContent
        this.ref.placeholder?.addEventListener('click', this.handleLoadClick)

        if (this.ref.video) {
            this.element.addEventListener('click', this.handlePlayingStateClick)

            this.ref.video.addEventListener('play', this.handlePlay)
            this.ref.video.addEventListener('pause', this.handlePause)
        }

        this.cursor = new CursorTrigger(this.element, {
            symbol: 'play',
        })
    }

    destroy() {
        if (this.cursor) {
            this.cursor.destroy()
        }
    }

    handleLoadClick = (event) => {
        if (!this.template) {
            return
        }

        this.ref.placeholder.innerHTML = substitute(this.template, {
            src: this.options.src,
        })

        if (!this.ref.video) {
            this.cursor?.disable()
        }
    }

    handlePlayingStateClick = (event) => {
        event.preventDefault()

        if (this.ref.video && this.ref.video.paused) {
            this.play()
        } else {
            this.pause()
        }
    }

    handlePause = (event) => {
        this.element.classList.remove(STATES.PLAYING)
    }

    handlePlay = (event) => {
        this.element.classList.add(STATES.PLAYING)
    }

    play() {
        if (this.options.controls) {
            this.ref.video.setAttribute('controls', true)
        }
        this.ref.video.play()
        if (this.cursor) {
            this.cursor.options.symbol = 'pause'
            this.cursor.enter()
        }
    }

    pause() {
        this.ref.video.pause()
        if (this.options.controls) {
            this.ref.video.removeAttribute('controls')
        }
        if (this.cursor) {
            this.cursor.options.symbol = 'play'
            this.cursor.enter()
        }
    }
}
